import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_KIT_COLETA } from "app/auth/baseKitColeta";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import { saveAs } from "file-saver";
import { IDownloadFileInfo } from "../slices/models";

export const getKitColeta = createAsyncThunk(
  "kitColetaApp/kitColeta/getKitColeta",
  async (data: any, { dispatch }) => {
    let response;
    try {
      response = await API_KIT_COLETA.get("/arquivos", {
        params: data,
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
    }
    return response.data;
  }
);

export const getKitColetaDownloadFile = createAsyncThunk(
  "kitColetaApp/kitColeta/getKitColetaDownloadFile",
  async (data: IDownloadFileInfo, { dispatch, rejectWithValue }) => {
    let response;
    try {
      response = await API_KIT_COLETA.get("/download", {
        params: data,
        paramsSerializer: {
          indexes: null,
        },
        responseType: "blob",
      });
      saveAs(
        response.data,
        `${
          data.nomeArquivo
            ? data.nomeArquivo
            : `kitcoleta-arquivos-${data.dataInicial}_to_${data.dataFinal}.zip`
        }`
      );
      return response.data;
    } catch (err) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      return rejectWithValue(err.data);
    }
  }
);
